import { useLocation, Link } from 'react-router-dom';
import "./BreadCrumb.css"
import { getRootUrl, useData} from '../../consts';
import { getPdtCatUpperGrp } from '../../components/PdtCatList/PdtCatList';
import { regUses, usePdtCats } from '../../axios_with_token';
import { useState } from 'react';

const rootUrl = getRootUrl();

export default function Breadcrumb({}) {

  const {regUse, isLoading, hasError, DefaultLoading, DefaultError} = regUses();

  const {data:pdtCats} = regUse(usePdtCats());

  const location = useLocation();
  const pathnames = (location.pathname||"").replace(`${rootUrl}/app2`, "/").split('/').filter((x) => x);
  const pathCaptions = pathnames.map((pathname, idx)=>{return {
    caption: pathname,
    name: pathname,
    catIdx: idx,
    routeTo: `/${pathnames.slice(0, idx + 1).join('/')}`,
    routeToBase: `/${pathnames.slice(0, idx).join('/')}`
  };})

  const [pageData, setPageData] = useState({});

  const pdtData = pageData.currentPdt || {};
  const catData = pageData.currentPdtCat || {};
  
  switch(pathnames[0]){
    // case 'pdtCatDetail':
    //   pathCaptions[0] = "";
    //   pathCaptions[pathnames.length-1] = (props.pdtCat||{}).name||'category';
    //   break;
    case 'pdtDetail':
      pathCaptions[0] = false;
      const upperCatsGrp = getPdtCatUpperGrp(pathCaptions[1].name, pdtCats);
      const catBase = pathCaptions[1];
      const pdtBase = pathCaptions[2];
      switch(pathnames.length){
        case 3: //product
          {
            // pathCaptions[1].caption = catData.name||'category';
            const tgtIdx = 1+upperCatsGrp.length;
            pathCaptions[tgtIdx] = {...pdtBase};
            pathCaptions[tgtIdx].caption = `${pdtData.name||'product'}${pdtData.sn?` (${pdtData.sn})`:''}`;
          }
        case 2: //category:
          {
            upperCatsGrp.forEach((pdtCat, pdtCatIdx)=>{
              const tgtIdx = 1+pdtCatIdx;
              pathCaptions[tgtIdx] = {...catBase};
              pathCaptions[tgtIdx].caption = pdtCat.name;
              pathCaptions[tgtIdx].routeTo = [pathCaptions[tgtIdx].routeToBase,pdtCat.__id].join('/');
              // [] *100+idx avoid duplicated key
              pathCaptions[tgtIdx].catIdx = pdtCatIdx==(upperCatsGrp.length-1)?pathCaptions[tgtIdx].catIdx:pathCaptions[tgtIdx].catIdx*100+pdtCatIdx;
            })
            // pathCaptions[1+upperCatsGrp.length] = pdtBase;
            // const upperCatsGrp = getPdtCatUpperGrp(pathCaptions[1].name, pdtCats);
            // console.log('upperCatsGrp:', upperCatsGrp);
            // pathCaptions[1].caption = catData.name||'category';

          }
          break;
      }
      break;
    case 'aboutUs':
      pathCaptions[0].caption = "About Us";
      break;
  }

  if(isLoading())return <DefaultLoading></DefaultLoading>;
  if(hasError())return <DefaultError></DefaultError>;

  return (
    pathnames.length<1?<></>:<nav aria-label="breadcrumb" className=' container'>
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link
            aria-current="page"
            to={`${rootUrl}/app2`}
            className="link-secondary text-decoration-none"
          >Home</Link>
        </li>
        {pathCaptions.filter(a=>a).map((captionDef, index) => {
          // .map((caption,idx)=>caption?{caption, catIdx:idx}:false)
          const {caption,catIdx,routeTo} = captionDef;
          const isLast = catIdx === pathnames.length - 1;
          // const caption = pathCaptions[index];
          return <li key={`${catIdx}-${index}`} className={`breadcrumb-item ${isLast ? 'active' : ''}`}>
              {isLast ? (
                caption
              ) : (
                <Link 
                    aria-current="page"
                    to={`${rootUrl}/app2/${routeTo}`.replace(/\/\//g, '/')}
                    className="link-secondary text-decoration-none"
                >{caption}</Link>
              )}
            </li>;
        })}
      </ol>
    </nav>
  );
}

// {(("/"+pathName.join("/"))!=`${rootUrl}/app2`)&&<div className="container">
// <div className="row">
//     <nav aria-label="breadcrumb">
//         <ol className="breadcrumb">
//             {pathName.map((seg,setIdx)=><li key={"seg-"+seg+setIdx} className="breadcrumb-item ">
//             <Link 
//                 aria-current="page"
//                 to={`${rootUrl}/app2`}
//                 className="link-secondary text-decoration-none"
//             >{seg}</Link>
//             </li>)}
//         </ol>
//     </nav>
// </div>
// </div>}